<template>
  <div>
    <filter-item v-if="this.$store.getters.authUser.can_access_all_leads">
      <filter-users
        store-module="inbox"
        :filter-name="filterName"
        :initial-user="userQuery"
        @change="usersFilterText = $event"
      ></filter-users>
    </filter-item>

    <filter-item>
      <filter-campaigns-multiple
        store-module="inbox"
        :filter-name="filterName"
        @change="campaignsFilterText = $event"
      />
    </filter-item>

    <filter-item>
      <filter-phone-numbers-multiple
        store-module="inbox"
        :filter-name="filterName"
        @change="phoneNumbersFilterText = $event"
      />
    </filter-item>

    <filter-item>
      <filter-sources
        labels="New Lead Source"
        help-text="This only pertains to new leads"
        store-module="inbox"
        :filter-name="filterName"
        @change="sourcesFilterText = $event"
      ></filter-sources>
    </filter-item>
  </div>
</template>

<script>
export default {
  name: "InboxFilters",
  props: {
    userQuery: {
      type: Number,
      default: null
    },
    filterName: {
      type: String,
      default: "inbox"
    }
  },
  data() {
    return {
      usersFilterText: null,
      campaignsFilterText: null,
      phoneNumbersFilterText: null,
      sourcesFilterText: null,
    };
  },
  computed: {
    filterText() {
      let array = [];

      if (this.usersFilterText) array.push(this.usersFilterText);
      if (this.campaignsFilterText) array.push(this.campaignsFilterText);
      if (this.phoneNumbersFilterText) array.push(this.phoneNumbersFilterText);
      if (this.sourcesFilterText) array.push(this.sourcesFilterText);

      return array.join(" | ");
    }
  },
  methods: {
    resetFilters() {
      this.usersFilterText = null;
      this.campaignsFilterText = null;
      this.phoneNumbersFilterText = null;
      this.sourcesFilterText = null;

      this.$store.commit("inbox/resetFilters", this.filterName);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.filter_item {
  padding: 0 8px 12px !important;
}
</style>
